import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '../../assets/img/avatar2.png'


const _hoisted_1 = { class: "nav-toolbar" }
const _hoisted_2 = { class: "tool-info" }
const _hoisted_3 = {
  key: 0,
  class: "dv-menu-title"
}
const _hoisted_4 = { class: "short-text" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  src: _imports_0,
  class: "profile-img"
}
const _hoisted_7 = { class: "spn-name" }

import { PropType, onMounted, onUnmounted, ref } from 'vue';
import { ISesionApp } from '@/core/model/sesion/ISesionApp';
import { useServicesFactoryStore } from '@/core/stores/services-factory-store';
import AppUIManagerService from '@/core/services/AppUIManagerService';
import { Subscription } from 'rxjs/internal/Subscription';
import ProfileConfigView from './ProfileConfigView.vue';
import Dialog from 'primevue/dialog';
import { IAppUserSettings } from '@/core/services/sys/AppSystemSettingsService';
import LoginService from '@/core/services/login/LoginService';


export default /*@__PURE__*/_defineComponent({
  __name: 'ToolbarView',
  props: {
    sesion: { type: Object as PropType<ISesionApp>, required:true }
},
  emits: ['onMenu'],
  setup(__props, { emit: __emit }) {


const emit = __emit;

const MenuSelect = ref<any>(null);
let MenuSubscription: Subscription|null=null;
const uiManager:AppUIManagerService = useServicesFactoryStore().getAppUIManagerService;
const loginService:LoginService = useServicesFactoryStore().getLoginService;
const showDialogOptions = ref<boolean>(false);
const imgUser = ref<string|null>(null);
const menuOpen = ()=>
{
    emit('onMenu',true);
}
const reloadPage = ()=>
{
    if(uiManager && uiManager.ReloadCurrentAction)
    {
        uiManager.ReloadCurrentAction();
    }
}
const viewOptions =()=>
{
    showDialogOptions.value = true;
}
const onSaved = (settings:IAppUserSettings) =>
{
    if(settings && settings.profileImg)
    {
        imgUser.value = 'data:image/png;base64,' + settings.profileImg;            
    }
    showDialogOptions.value = false;
}
onMounted(async()=>
{                           
    const appSettings = await loginService.getAppSettings(); 
    imgUser.value = appSettings.profileImg? 'data:image/png;base64,' + appSettings.profileImg:null;    
    MenuSubscription = uiManager.ActiveMenu.subscribe((x: any) => { MenuSelect.value = x; });
});
onUnmounted(() => {
    if(MenuSubscription)
    MenuSubscription.unsubscribe();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "menu-bars-small",
        onClick: menuOpen
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "pointer" }, [
          _createElementVNode("i", { class: "pi pi-bars" })
        ], -1)
      ])),
      _createElementVNode("div", _hoisted_2, [
        (MenuSelect.value && MenuSelect.value.data && MenuSelect.value.data.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t(`menus.menu_${MenuSelect.value.data.title}`)), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", { class: "tool-options" }, [
        _createElementVNode("div", {
          class: "pointer dv-command",
          onClick: reloadPage
        }, _cache[2] || (_cache[2] = [
          _createElementVNode("i", { class: "pi pi-undo" }, null, -1)
        ])),
        _createElementVNode("div", {
          class: "pointer dv-command",
          onClick: viewOptions
        }, _cache[3] || (_cache[3] = [
          _createElementVNode("i", { class: "pi pi-cog" }, null, -1)
        ])),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "pointer dv-command d-none" }, [
          _createElementVNode("i", { class: "pi pi-bell" })
        ], -1))
      ]),
      _createElementVNode("div", {
        class: "tool-usr-info pointer",
        onClick: viewOptions
      }, [
        (imgUser.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: imgUser.value,
              class: "profile-img"
            }, null, 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("img", _hoisted_6)),
        _createElementVNode("span", _hoisted_7, _toDisplayString(__props.sesion.FullName), 1),
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "spn-profile" }, [
          _createElementVNode("b", null, "Root")
        ], -1))
      ])
    ]),
    _createVNode(_unref(Dialog), {
      visible: showDialogOptions.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((showDialogOptions).value = $event)),
      modal: "",
      header: _ctx.$t('Users.Options')
    }, {
      default: _withCtx(() => [
        _createVNode(ProfileConfigView, {
          sesion: __props.sesion,
          onOnSave: onSaved
        }, null, 8, ["sesion"])
      ]),
      _: 1
    }, 8, ["visible", "header"])
  ], 64))
}
}

})